import { Tag } from '@optimus-web/core';
import { DetailedUser, SecurityFeatures } from '@mews-commander/data-access';
import { TooltippedTag } from '@mews-commander/ui';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';

export const SecurityStatus = ({ securityFeatures }: Pick<DetailedUser, 'securityFeatures'>) => {
    if (securityFeatures?.includes(SecurityFeatures.SsoEnforced)) {
        return (
            <Tag variant="success">
                <LocalizedText textKey={TextKey.UserSecurityStatusTagSso} />
            </Tag>
        );
    }

    if (securityFeatures?.includes(SecurityFeatures.MfaEnabled)) {
        return (
            <Tag variant="success">
                <LocalizedText textKey={TextKey.UserSecurityStatusTagMFA} />
            </Tag>
        );
    }

    return (
        <TooltippedTag
            variant="warning"
            tooltip={<LocalizedText textKey={TextKey.UserSecurityStatusTooltipNotSecured} />}
        >
            <LocalizedText textKey={TextKey.UserSecurityStatusTagNotSecured} />
        </TooltippedTag>
    );
};
